import React, { useState } from "react";
import "./SignUp.css";
import vendorimg from "../../../assets/Component 24.png";
import finkraft from "../../../assets/finkraft.png";
import { useNavigate,useLocation } from "react-router-dom";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Link } from 'react-router-dom';
import checkmark from "../../../assets/i.png";
import { toast } from 'react-toastify';
import { getAuth, fetchSignInMethodsForEmail } from "firebase/auth"
import { HiOutlineUserRemove } from 'react-icons/hi'; // or MdPersonOff

import { Eye, EyeOff } from 'lucide-react';

const SignUP = () => {

  const location = useLocation();
  const prefilledEmail = location.state?.email || ""; // 👈 grab email from location state
  console.log("prefilledEmail",prefilledEmail)
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false); // Separate state for confirm password
  const [showPopup, setShowPopup] = useState(false);
  
  const styles = {
    overlay: {
      position: 'fixed',
      top: 0, left: 0, right: 0, bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.4)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000,
    },
    modal: {
      background: '#ffffff',
      padding: '30px',
      borderRadius: '16px',
      textAlign: 'center',
      width: '340px',
      boxShadow: '0 10px 30px rgba(0, 0, 0, 0.2)',
      fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
      animation: 'fadeIn 0.3s ease-in-out',
    },
    iconContainer: {
      marginBottom: '12px',
    },
    icon: {
      fontSize: '50px',
      color: '#e53935', // red tone to show "access denied" / user issue
    },
    title: {
      fontSize: '20px',
      fontWeight: '600',
      marginBottom: '10px',
      color: '#333',
    },
    message: {
      fontSize: '16px',
      fontWeight: '400',
      marginBottom: '20px',
      color: '#555',
    },
    button: {
      padding: '10px 24px',
      backgroundColor: '#007b8f',
      color: '#fff',
      border: 'none',
      borderRadius: '8px',
      fontSize: '15px',
      fontWeight: '500',
      cursor: 'pointer',
      transition: 'background-color 0.2s ease-in-out',
    },
  };
  

  const [email, setEmail] = useState(prefilledEmail);
    const [password, setPassword] = useState('');
    const [confirm, setConfirm] = useState('');
    const navigate = useNavigate();

    const [errors, setErrors] = useState({
      password: "",
      confirm: "",
      allFields: ""
    });


    const handleContinue = async () => {
      let tempErrors = {
        password: "",
        confirm: "",
        allFields: ""
      };
    
      if (!email || !password || !confirm) {
        tempErrors.allFields = "All fields are required";
        setErrors(tempErrors);
        return;
      }
    
      const alphanumericRegex = /^(?=.*[A-Za-z])(?=.*\d).{6,}$/;

        if (!alphanumericRegex.test(password)) {
          tempErrors.password = "Password must be at least 6 characters and contain both letters and numbers";
          setErrors(tempErrors);
          return;
        }

    
      if (password !== confirm) {
        tempErrors.confirm = "Passwords don't match";
        setErrors(tempErrors);
        return;
      }
    
      setErrors({ password: "", confirm: "", allFields: "" });
    
      try {
        // 🔍 Step 1: Check if email exists in Firebase
        const checkRes = await fetch("https://vendor-score.finkraftai.com/check-user", { // Change URL to your Flask backend
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email }),
        });
    
        const checkData = await checkRes.json();
    
        if (checkData.exists) {
          // 🧃 Show popup and STOP further execution
          // toast.info("User already exists. Please login instead.");
          setShowPopup(true);

        // Optional: Auto-close after 3 seconds
        setTimeout(() => {
          setShowPopup(false);
        }, 8000);
          return;
        }
    
        // ✅ Step 2: Email does NOT exist — send OTP
        const res = await fetch("https://vendor-score.finkraftai.com/send-otp", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email }),
        });
    
        const data = await res.json();
    
        if (data.success) {
          toast.success("OTP sent successfully!");
          navigate("/verification", { state: { email, password } });
        } else {
          toast.error("Failed to send OTP");
        }
      } catch (err) {
        console.error("Error occurred:", err);
        toast.error("Something went wrong");
      }
    };
    
    
    
    



  return (
    <div className="login-page-main">
      <ToastContainer position="top-center" autoClose={3000} />
      {showPopup && (
        <div style={styles.overlay}>
          <div style={styles.modal}>
            <div style={styles.iconContainer}>
              <HiOutlineUserRemove style={styles.icon} />
            </div>
            <div style={styles.title}>User Already Exists</div>
            <div style={styles.message}>
              This email is already registered. Please log in instead.
            </div><Link to="/login">
            <button style={styles.button} onClick={() => setShowPopup(false)}>
              Go to Login
            </button></Link>
          </div>
        </div>
      )}

    <div className="login-container">
      <div className="logo">
        <img src={finkraft} alt="Logo" className="logo-img" />
      </div>

      <div className="signup-box">
        <h1 className="welcome-text">Let’s get you started</h1>
        <p className="subtext">Kindly provide the following information and begin your signup process.</p>

        <label className="label">Email Address</label>
        <input
            type="email"
            className="input"
            value={email}
            readOnly
            disabled
          />


{/* <label className="label">Password</label>
<input
  type="password"
  placeholder="Enter password"
  className={`input ${errors.password && "input-error"}`}
  onChange={(e) => setPassword(e.target.value)}
/>
{errors.password && <p className="error-msg">{errors.password}</p>} */}

<div className="input-wrapper" style={{ position: 'relative', marginBottom: '20px' }}>
        <label className="label">Password</label>
        <input
          type={showPassword ? 'text' : 'password'}
          placeholder="Enter password"
          className={`input ${errors.password ? 'input-error' : ''}`}
          value={password}
          onChange={(e) => {
            setPassword(e.target.value);
          }}
          style={{
            width: '100%',
            borderRadius: '5px',
            fontSize: '14px',
            position: 'relative',
          }}
        />
        <span
          className="toggle-password-icon"
          style={{
            position: 'absolute',
            right: '0px',
            top: '70%',
            transform: 'translateY(-50%)',
            cursor: 'pointer',
            color: '#007b8f',
          }}
          onClick={() => setShowPassword((prev) => !prev)} // Toggle only for password
        >
          {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
        </span>
        {errors.password && <p className="error-msg" style={{
          color: 'red',
          fontSize: '12px',
          marginTop: '5px',
          marginBottom: '0',
          position: 'absolute',
          top: '100%',
          left: '0',
        }}>{errors.password}</p>}
      </div>


      <div className="input-wrapper">
        <label className="label">Confirm Password</label>
        <input
          type={showConfirmPassword ? 'text' : 'password'}
          placeholder="Enter password"
          className={`input ${errors.confirm ? 'input-error' : ''}`}
          value={confirm}
          onChange={(e) => {
            setConfirm(e.target.value);
          }}
        />
        <span
          className="toggle-password-icon"
          style={{
            position: 'absolute',
            right: '0px',
            top: '70%',
            transform: 'translateY(-50%)',
            cursor: 'pointer',
            color: '#007b8f',
          }}
          onClick={() => setShowConfirmPassword((prev) => !prev)} // Toggle only for confirm password
        >
          {showConfirmPassword ? <EyeOff size={18} /> : <Eye size={18} />}
        </span>
        {errors.confirm && <p className="error-msg" style={{
          color: 'red',
          fontSize: '12px',
          marginTop: '5px',
          marginBottom: '0',
          position: 'absolute',
          top: '100%',
          left: '0',
        }}>{errors.confirm}</p>}
      </div>


        <button className="continue-button" onClick={handleContinue}>Continue</button>

        <p className="signup-text">
        Already have an account?<Link to="/login">Log in.</Link>
        </p>
      </div>
    </div>
    <div className="vendor-image-container">
        <img src={vendorimg}  className="vendor-image"/>
    </div>
    </div>
    
  );
};

export default SignUP;
